module.exports = __webpack_public_path__ + "joy-static/media/RepostionCamera.9c8c8abb.png";